












import Vue from "vue"
import PPublicStatusRadios from "./PPublicStatusRadios.vue"
import Overlay from "~/components/guideline/modal/Overlay.vue"

export default Vue.extend({
  components: {
    Overlay,
    PPublicStatusRadios,
  },
  props: {
    isShown: {
      type: Boolean,
      required: true,
    },
    currentPublicStatus: {
      type: String,
      required: true,
    },
  },
  methods: {
    updateValue(value: string) {
      this.$emit("click-radio", value)
    },
    handleOverlayClick() {
      this.$emit("click-overlay")
    },
  },
})
